module.exports = __webpack_public_path__ + "static/media/GACertified.d6eec675.jpg";